export default {
  common: {
    email: 'Email',
    password: 'Password',
    firstName: 'First Name',
    lastName: 'Last Name',
    locale: 'Language',
    signIn: 'Sign in',
    signUp: 'Sign up',
    dontHaveAccountQuestion: "Don't have an account?",
    createAccount: 'Create one here',
    alreadyHaveAnAccount: 'Already have an account?',
    forgotPassword: 'Forgot password?',
    forgotPasswordLegend:
      'Enter your email and we’ll help you reset your password',
    resetPassword: 'Reset Password',
    newPassword: 'New Password',
    updatePassword: 'Update Password',
    updateSettings: 'Update Settings',
    accountSettings: 'Account settings',
    signOut: 'Sign out',
    errorMessage: 'There was an error',
    resetPasswordSuccess: 'An email has been sent with your new password',
    changePasswordSuccess: 'Your password has been changed successfully',
    updateSettingsSuccess: 'Your settings have been updated successfully',
    pageNotFoundTitle: '404',
    pageNotFoundLegend:
      "It seems like the page you are looking for doesn't exist",
    goBackHome: 'Go back home',
    selectLanguage: 'Select language',
    selectOption: 'Select an option',
    errorBoundaryMessage: 'An error occurred',
    reportError: 'Report error',
  },
};
